import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin, Observable, of, Subscription } from 'rxjs';
import { EmailTemplate, IEmailTemplateList } from '../models/email-template';
import { BaseRestService } from './base-rest.service';
import { OrganisationService } from './organisation.service';
import { SubjectTypeService } from './subject-type.service';
import { AutoUnsubscribe } from 'auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Injectable({ providedIn: 'root' })
export class EmailTemplateService
  extends BaseRestService<EmailTemplate, IEmailTemplateList>
  implements OnDestroy
{
  organisationSaved: Subscription;
  organisationDeleted: Subscription;
  mailMergeVariableFields = '';

  constructor(
    http: HttpClient,
    protected router: Router,
    private organisationService: OrganisationService,
    private subjectTypeService: SubjectTypeService
  ) {
    super(
      EmailTemplateService,
      http,
      'api/emailtemplate',
      'email template',
      router
    );
    this.cacheEnabled = true;

    this.organisationSaved = this.organisationService.onAfterSave.subscribe(
      (_) => {
        this.clearCache();
      }
    );

    this.organisationDeleted = this.organisationService.onDeleted.subscribe(
      (_) => {
        this.clearCache();
      }
    );
  }

  ngOnDestroy() {
    this.organisationSaved?.unsubscribe();
    this.organisationDeleted?.unsubscribe();
  }

  afterSave() {
    this.subjectTypeService.refresh();
  }

  hydrate(item: EmailTemplate): Observable<EmailTemplate> {
    return of(item);
  }
}
